/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createAbs } from '../../factoriesAny.js';
export var absDependencies = {
  typedDependencies: typedDependencies,
  createAbs: createAbs
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAbs.generated.js
// module id = 54
// module chunks = 0